// FASE D — honest "who uses it / for what" trust section. Factual use-case
// cards (schools, parties, offices, weddings, music nights, care) that act as
// relatable social proof WITHOUT any fabricated reviews, ratings or counts.
import { GraduationCap, PartyPopper, Briefcase, Heart, Music, HandHeart } from "lucide-react";
import { useI18n } from "../lib/i18n";

const CASES = [
  { key: "school", icon: GraduationCap, color: "var(--brand-blue)" },
  { key: "party", icon: PartyPopper, color: "var(--brand-red)" },
  { key: "office", icon: Briefcase, color: "#0E5C2F" },
  { key: "wedding", icon: Heart, color: "#EC407A" },
  { key: "music", icon: Music, color: "#6B2BD9" },
  { key: "care", icon: HandHeart, color: "#FF6F00" },
];

export default function UseCases() {
  const { t } = useI18n();
  return (
    <div data-testid="use-cases">
      <div className="text-center mb-8 sm:mb-10">
        <div className="inline-flex items-center gap-2 nb-border bg-white px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest nb-shadow-sm mb-3">
          {t("usecases_badge")}
        </div>
        <h2 className="font-display font-black text-3xl sm:text-5xl tracking-tight mb-3" data-testid="use-cases-h">
          {t("usecases_h")}
        </h2>
        <p className="text-base sm:text-lg text-neutral-700 max-w-2xl mx-auto font-medium">
          {t("usecases_p")}
        </p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
        {CASES.map(({ key, icon: Icon, color }) => (
          <div key={key} className="nb-card rounded-md p-5 bg-white flex items-start gap-4" data-testid={`use-case-${key}`}>
            <span className="w-11 h-11 rounded-md nb-border flex items-center justify-center flex-shrink-0 nb-shadow-sm" style={{ backgroundColor: color, color: "#fff" }}>
              <Icon size={20} strokeWidth={2.2} />
            </span>
            <div className="min-w-0">
              <div className="font-display font-black text-lg leading-tight mb-1">{t(`uc_${key}_h`)}</div>
              <p className="text-sm text-neutral-700 font-medium leading-snug">{t(`uc_${key}_p`)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
